import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './admin-cards.loaders';
import { adminBrandCardsKeys } from './admin-cards.queries';

export const useAdminCreateCard = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createCard, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminBrandCardsKeys.all);
    },
  });
};

export const useAdminUpdateCard = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateCard, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminBrandCardsKeys.all);
    },
  });
};

export const useAdminUpdateCardContent = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateCardContent, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminBrandCardsKeys.all);
    },
  });
};

export const useAdminUpdateCardPrices = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateCardPrices, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminBrandCardsKeys.all);
    },
  });
};

export const useAdminDeleteCard = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteCard, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminBrandCardsKeys.lists);
    },
  });
};

export const useDownloadBulkUpdateTemplate = () => {
  return useMutation(loaders.downloadBulkUpdateTemplate, {
    onSuccess: filesConverters.export,
  });
};

export const useImportAdminCardsBulkUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.importBulkUpdate, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminBrandCardsKeys.lists);
    },
  });
};

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};
